const Tag = ({ quality, name }) => {
  return (
    <div
      style={{
        background:
          quality === "GREEN"
            ? "#F1FCF4"
            : quality === "RED"
              ? "#FEF3F2"
              : quality === "UNKNOWN"
                ? "#FAFAFA"
                : quality === "YELLOW"
                  ? "#FFFFEA"
                  : quality === "BLUE"
                    ? "#EEFAFF"
                    : "",
        border:
          quality === "GREEN"
            ? "1px solid #C0F2CF"
            : quality === "RED"
              ? "1px solid #FFCCC8"
              : quality === "UNKNOWN"
                ? "1px solid #E4E4E7"
                : quality === "YELLOW"
                  ? "1px solid #FFF885"
                  : quality === "BLUE"
                    ? "1px solid #BDEBFF"
                    : "",
        padding: "2px 10px",
        borderRadius: "50px",
      }}
    >
      <span
        style={{
          color:
            quality === "GREEN"
              ? "#219848"
              : quality === "RED"
                ? "#E22D20"
                : quality === "UNKNOWN"
                  ? "#3F3F46"
                  : quality === "YELLOW"
                    ? "#E29400"
                    : quality === "BLUE"
                      ? "#2196F3"
                      : "",
          fontSize: "14px",
          lineHeight: "20px",
          fontWeight: "400",
        }}
      >
        {name}
      </span>
    </div>
  );
};

export default Tag;
